import { render, staticRenderFns } from "./CashboxCategory.vue?vue&type=template&id=c4de7c90&scoped=true"
import script from "./CashboxCategory.vue?vue&type=script&lang=js"
export * from "./CashboxCategory.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CashboxCategory.vue?vue&type=style&index=1&id=c4de7c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4de7c90",
  null
  
)

export default component.exports